module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/vaccine/vaccine.html
// module id = 663
// module chunks = 0